<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="AgencesList">
    <!-- ACTIONS -->
    <actions
      :agenceQuery="true"
      :queryConfig="agencesQueryConfig"
      @onAgencesFilter="onAgencesFilter($event)"
      @reloadData="reloadAgencesData($event)"
      @newAgenceModal="openModalAgence"
      @search="updateSearchQuery"
    ></actions>

    <page-loader v-if="loading" :hasActions="true"></page-loader>

    <!-- EMPTY STATE -->
    <empty-state
      v-if="!getAgences.content || !getAgences.content.length"
      module="agences"
      title="Commencer à créer votre agence."
      description="Vous n'avez aucune agence."
      :addAgence="true"
      @newAgenceModal="openModalAgence"
    ></empty-state>

    <!-- AGENCES -->
    <div v-if="getAgences.content.length && !loading">
      <b-row v-if="!loading" align-items="stretch">
        <b-col cols="12" xl="12" class="my-4">
          <table class="giga-table" :aria-describedby="$t('agences')">
            <thead>
              <tr>
                <th
                  @click="sortAgencesTable('raisonSocial')"
                  class="sort"
                  scope="col"
                  :class="sortAgencesClass('raisonSocial')"
                >
                  {{ $t("agence_name") }}
                  <img
                    v-if="sortAgencesClass('raisonSocial')"
                    :src="
                      sortAgencesClass('raisonSocial') === 'desc'
                        ? descIcon
                        : ascIcon
                    "
                    class="sort-icon"
                    alt="sort-icon"
                  />
                </th>

                <th
                  @click="sortAgencesTable('siret')"
                  class="sort"
                  scope="col"
                  :class="sortAgencesClass('siret')"
                >
                  SIRET
                  <img
                    v-if="sortAgencesClass('siret')"
                    :src="
                      sortAgencesClass('siret') === 'desc' ? descIcon : ascIcon
                    "
                    class="sort-icon"
                    alt="icon"
                  />
                </th>
                <th
                  @click="sortAgencesTable('address')"
                  class="sort"
                  scope="col"
                  :class="sortAgencesClass('address')"
                >
                  {{ $t("company_address") }}
                  <img
                    v-if="sortAgencesClass('address')"
                    :src="
                      sortAgencesClass('address') === 'desc'
                        ? descIcon
                        : ascIcon
                    "
                    class="sort-icon"
                    alt="icon"
                  />
                </th>
                <th scope="col" class="actions-cell">
                  <!-- {{ $t("agence_actions") }} -->
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="agence in getAgences.content">
                <tr
                  :class="{ inactiveAgence: !agence.isEnabled }"
                  class="cursor-pointer"
                  :key="agence.id"
                >
                  <td :data-label="$t('agence_name')">
                    <p>{{ agence.raisonSocial }}</p>
                  </td>
                  <td data-label="siret">{{ agence.siret }}</td>
                  <td :data-label="$t('company_address')">
                    <p>{{ agence.address }} {{ agence.city }}</p>
                  </td>
                  <td :data-label="$t('agence_actions')">
                    <ul class="agence-actions">
                      <li class="agence-action_detail">
                        <button @click="goToTeamAgence(agence.id)">
                          <svg
                            width="22"
                            height="16"
                            viewBox="0 0 22 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#b33t59huwa)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11 .5C6 .5 1.73 3.61 0 8c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C20.27 3.61 16 .5 11 .5zM11 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8C9.34 5 8 6.34 8 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                                fill="#fff"
                              />
                            </g>
                            <defs>
                              <clipPath id="b33t59huwa">
                                <path fill="#fff" d="M0 0h22v16H0z" />
                              </clipPath>
                            </defs>
                          </svg>
                        </button>
                      </li>

                      <li class="agence-action_edit">
                        <button @click="openModalModifAgence(agence)">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0 12.8538V15.5556C0 15.8045 0.195528 16 0.444383 16H3.14623C3.26177 16 3.37731 15.9556 3.4573 15.8667L13.1626 6.17025L9.82975 2.83738L0.133315 12.5338C0.0444383 12.6227 0 12.7293 0 12.8538ZM15.74 3.59283C16.0867 3.24622 16.0867 2.68629 15.74 2.33968L13.6603 0.259964C13.3137 -0.0866546 12.7538 -0.0866546 12.4072 0.259964L10.7807 1.8864L14.1136 5.21928L15.74 3.59283Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </li>
                      <!--                    activate/desactivate agences-->
                      <!--                    <li v-if="getActivateAgenceLoader && agence.shouldLoading" class="agence-action_delete">-->
                      <!--                      <b-spinner-->
                      <!--                          style="width: 1.5rem; height: 1.5rem;"-->
                      <!--                          variant="primary" class="mr-2 align-middle">-->
                      <!--                      </b-spinner>-->
                      <!--                    </li>-->
                      <!--                    <li v-else class="agence-action_delete">-->
                      <!--                        <button v-if="agence.isEnabled"-->
                      <!--                                @click="desactivateAgence(agence.id)"-->
                      <!--                                data-toggle="tooltip"-->
                      <!--                                title="Désactiver"-->
                      <!--                        >-->

                      <!--                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                      <!--                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.06089 4.04058C7.19005 3.29268 8.54415 2.85714 10 2.85714C13.9449 2.85714 17.1429 6.05509 17.1429 10C17.1429 11.4558 16.7073 12.81 15.9594 13.9391L6.06089 4.04058ZM4.04058 6.06089C3.29268 7.19005 2.85714 8.54415 2.85714 10C2.85714 13.9449 6.05509 17.1429 10 17.1429C11.4558 17.1429 12.81 16.7073 13.9391 15.9594L4.04058 6.06089ZM10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0Z" fill="#FF6D64"/>-->
                      <!--                          </svg>-->
                      <!--                        </button>-->
                      <!--                        <button v-else-->
                      <!--                                @click="activateAgence(agence.id)"-->
                      <!--                                data-toggle="tooltip" title="Activer"-->
                      <!--                        >-->
                      <!--                          <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                      <!--                            <path d="M8.08424 15C7.78852 15 7.50451 14.8876 7.29478 14.6866L1.32713 8.96822C0.890957 8.55045 0.890957 7.87285 1.32713 7.45484C1.76307 7.03684 2.47035 7.03661 2.90629 7.45484L8.03838 12.3722L18.3002 1.35737C18.7108 0.916927 19.4166 0.878011 19.8769 1.27175C20.337 1.66549 20.3771 2.34195 19.9663 2.78284L8.91717 14.6424C8.7127 14.862 8.42272 14.9911 8.11577 14.9995C8.10526 14.9998 8.09475 15 8.08424 15Z" fill="#6CBE3E" stroke="#6CBE3E" stroke-width="1.5"/>-->
                      <!--                          </svg>-->
                      <!--                        </button>-->
                      <!--                    </li>-->
                    </ul>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <pagination
            :length="length"
            :rows="agencesRows"
            :perPage="agencePagedFilter.myPager.size"
            :currentPage="agencePagedFilter.myPager.page"
            v-on:changePerPage="changeAgencePerPage($event)"
            v-on:changeCurrentPage="changeAgenceCurrentPage($event)"
          ></pagination>
        </b-col>
      </b-row>
    </div>

    <agence-modal
      :id="agenceModalId"
      :title="modalTitle"
      :agenceForm="agenceForm"
      :isReadOnly="isReadOnly"
      fontSize="h3"
      backdrop-close="false"
      @confirmClick="onAgenceModalConfirm()"
      @closeClick="closeModalAgence()"
    ></agence-modal>
  </div>
</template>

<script>
import { agenceService } from "@/views/service/agence.service";
import { mapActions, mapGetters } from "vuex";
import { queryConstant } from "@/shared/queryConstant";
// import FilterModal from "@/components/static/FilterModal";
import Pagination from "@/components/static/Pagination";
import Actions from "../../components/static/Actions.vue";
import PageLoader from "../../components/static/pageLoader.vue";
import EmptyState from "../../components/static/emptyState.vue";
import AgenceModal from "@/views/Agences/AgenceModal.vue";

export default {
  name: "Agences",
  data: function() {
    const _pageSize_10 = 10;
    const _pageSize_25 = 25;
    const _pageSize_50 = 50;
    return {
      descIcon: require("@/assets/images/icons/desc.svg"),
      ascIcon: require("@/assets/images/icons/asc.svg"),
      agenceModalId: "",
      modalTitle: "",
      isReadOnly: false,
      roles: [],
      agenceForm: {
        siret: "",
        raisonSocial: "",
        address: "",
        city: "",
        postalCode: "",
        isEnabled: true
      },
      scrollBarSettings: {
        scrollXMarginOffset: 50
      },
      agencePagedFilter: {
        myPager: {
          page: 1,
          size: 10,
          defaultSort: "id",
          defaultOrder: true
        },
        search: "",
        customFilter: queryConstant.setDefaultCustomFilter()
      },
      length: [_pageSize_10, _pageSize_25, _pageSize_50],
      agencesQueryConfig: queryConstant.AGENCES_CONFIG
    };
  },
  methods: {
    ...mapActions("notification", ["openModal", "closeModal"]),
    ...mapActions("agence", ["changeActivation", "lookupAgencesAction"]),
    goToTeamAgence(agenceId) {
      this.$router.push({ name: "TeamAgence", params: { id: agenceId } });
    },

    updateSearchQuery(agenceSearch) {
      this.agencePagedFilter.search = agenceSearch;
      this.fetchAgences();
    },
    desactivateAgence(id) {
      const isEnabled = false;
      const pagedFilter = this.agencePagedFilter;
      this.changeActivation({ id, isEnabled, pagedFilter });
    },
    activateAgence(id) {
      const isEnabled = true;
      const pagedFilter = this.agencePagedFilter;
      this.changeActivation({ id, isEnabled, pagedFilter });
    },

    doOpenAgenceModal() {
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: this.agenceModalId });
      }, 1);
    },
    openModalAgence() {
      this.agenceModalId = "addAgence";
      this.modalTitle = "Ajouter une agence";
      this.doOpenAgenceModal();
    },
    openModalModifAgence(agence) {
      this.agenceModalId = "modifyAgence";
      this.modalTitle = "Modifier Agence";
      this.agenceForm.id = agence.id;
      this.agenceForm.raisonSocial = agence.raisonSocial;
      this.agenceForm.siret = agence.siret;
      const postalCodeMatch = agence.address.match(/\b\d{5}\b/);

      if (postalCodeMatch) {
        const postalCode = postalCodeMatch[0];
        this.agenceForm.postalCode = postalCode;
        this.agenceForm.address = agence.address.replace(postalCode, "").trim();
      } else {
        this.agenceForm.postalCode = "";
        this.agenceForm.address = agence.address;
      }
      this.agenceForm.city = agence.city;
      this.agenceForm.isEnabled = agence.isEnabled;
      this.doOpenAgenceModal();
    },

    changeAgencePerPage(perPage) {
      this.agencePagedFilter.myPager.page = 1;
      this.agencePagedFilter.myPager.size = perPage;

      this.fetchAgences();
    },

    closeModalAgence() {
      this.closeModal({ instance: this.$root, id: this.agenceModalId });
      this.isReadOnly = false;
      this.agenceForm = {
        siret: "",
        raisonSocial: "",
        address: "",
        city: "",
        postalCode: "",
        isEnabled: true
      };
    },
    onAgencesFilter({ filter }) {
      this.agencePagedFilter.customFilter = filter.custom;
      this.agencePagedFilter.myPager.page = 1;
      this.fetchAgences();
    },
    reloadAgencesData(filter) {
      this.onAgencesFilter(filter);
    },
    sortAgencesTable(name) {
      if (name === this.agencePagedFilter.myPager.defaultSort) {
        this.agencePagedFilter.myPager.defaultOrder = !this.agencePagedFilter
          .myPager.defaultOrder;
      } else {
        this.agencePagedFilter.myPager.defaultOrder = true;
      }
      this.agencePagedFilter.myPager.defaultSort = name;
      this.fetchAgences();
    },
    changeAgenceCurrentPage(currentPage) {
      this.agencePagedFilter.myPager.page = currentPage;
      this.fetchAgences();
    },
    sortAgencesClass(sort) {
      return this.agencePagedFilter.myPager.defaultSort === sort
        ? this.agencePagedFilter.myPager.defaultOrder
          ? "asc"
          : "desc"
        : "";
    },
    fetchAgences() {
      this.lookupAgencesAction({ pagedFilter: this.agencePagedFilter });
    },

    onAgenceModalConfirm() {
      if (this.agenceModalId === "modifyAgence") {
        this.onModifAgenceModalConfirm();
      } else {
        this.onAddAgenceModalConfirm();
      }
    },
    onAddAgenceModalConfirm() {
      const data = {
        siret: this.agenceForm.siret,
        raisonSocial: this.agenceForm.raisonSocial,
        address: `${this.agenceForm.address} ${this.agenceForm.postalCode}`,
        city: this.agenceForm.city,
        isEnabled: true
      };

      agenceService.addAgence(data).then(() => {
        this.closeModalAgence();
        this.agenceForm = {
          siret: "",
          raisonSocial: "",
          address: "",
          city: "",
          postalCode: "",
          isEnabled: true
        };
        this.fetchAgences();
      });
    },
    onModifAgenceModalConfirm() {
      const data = {
        id: this.agenceForm.id,
        siret: this.agenceForm.siret,
        raisonSocial: this.agenceForm.raisonSocial,
        address: `${this.agenceForm.address} ${this.agenceForm.postalCode}`,
        city: this.agenceForm.city,
        isEnabled: this.agenceForm.isEnabled
      };

      agenceService.modifyAgence(data).then(() => {
        this.closeModalAgence();
        this.agenceForm = {
          siret: "",
          raisonSocial: "",
          address: "",
          city: "",
          postalCode: "",
          isEnabled: true
        };
        this.fetchAgences();
      });
    }
  },
  components: { AgenceModal, Pagination, Actions, PageLoader, EmptyState },
  computed: {
    ...mapGetters("loader", {
      getActivateAgenceLoader: "getActivateAgenceLoader",
      loading: "getLoading"
    }),
    ...mapGetters("agence", ["getAgences"]),

    agencesRows() {
      return this.getAgences.totalElements;
    }
  },
  created() {
    this.fetchAgences();
  }
};
</script>

<style scoped>
img.sort-icon {
  width: 7px;
  height: 15px;
  margin: 1px 1px 2px 7px;
  object-fit: contain;
}


  th {
    cursor: pointer;
  }
  .giga-table thead th:first-child {
    width: auto !important;
  }
  .giga-table thead th:nth-child(4) {
    width: auto !important; }
</style>
